import React from 'react';

/**
 * StatCard Component
 * Displays a statistic with icon, value, label, and optional trend
 * Matches the design from the Sales Dashboard PDF
 */
const StatCard = ({
  icon: Icon,
  value,
  label,
  trend,
  trendLabel = "from yesterday",
  bgColor = "bg-pastel-pink",
  iconColor = "bg-danger-500",
  iconBgColor = "bg-white"
}) => {
  const isPositiveTrend = trend && trend > 0;
  const isNegativeTrend = trend && trend < 0;

  return (
    <div className={`${bgColor} rounded-card p-6 shadow-card hover:shadow-card-hover transition-shadow duration-200`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          {/* Icon Circle */}
          <div className={`${iconBgColor} ${iconColor} w-12 h-12 rounded-full flex items-center justify-center mb-4`}>
            {Icon && <Icon className="w-6 h-6 text-white" />}
          </div>

          {/* Value */}
          <div className="text-3xl font-bold text-neutral-900 mb-1">
            {value}
          </div>

          {/* Label */}
          <div className="text-sm font-medium text-neutral-600 mb-2">
            {label}
          </div>

          {/* Trend */}
          {trend !== undefined && (
            <div className="flex items-center text-xs">
              <span className={`font-semibold ${
                isPositiveTrend ? 'text-success-600' :
                isNegativeTrend ? 'text-danger-600' :
                'text-neutral-500'
              }`}>
                {isPositiveTrend && '+'}{trend}%
              </span>
              <span className="text-neutral-500 ml-1">
                {trendLabel}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
